<template>
  <OverlayCard width="m" data-test-id="limited-version-card" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('licensing.limitedVersionCard.text.title') }}
    </template>

    <template #content>
      <p v-html="mainText" />
    </template>

    <template #footer>
      <LicenseTrialAction v-if="canHaveTrial" />

      <LicenseUpgradeAction :color="canHaveTrial ? 'blue' : 'grey'" />
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import LicenseTrialAction from '@components/license/LicenseTrialAction';
import LicenseUpgradeAction from '@components/license/LicenseUpgradeAction';

export default defineComponent({
  emits: { cancel: null },
  name: 'LimitedVersionNotice',

  components: {
    LicenseTrialAction,
    LicenseUpgradeAction,
  },

  props: {
    canHaveTrial: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    mainText(): string {
      return this.$t(
        this.canHaveTrial
          ? 'licensing.limitedVersionCard.text.trialOrUpgrade'
          : 'licensing.limitedVersionCard.text.upgrade'
      );
    },
  },
});
</script>
